import { cacheOnce } from '@koob/utils';
import { get } from './';

export const getLocales = cacheOnce(() => get(`/languages`));
